import { createSelector } from 'reselect';

const selectAdminLevelThree = (state: any) => state.AdminLevelThree;


export const selectAdminLevelThreeCurrentItem = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.current);

export const selectAdminLevelThreeListItems = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectAdminLevelThreeListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAdminLevelThreeQueryItems = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.query);

export const selectAdminLevelThreeCreatedItem = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.create);

export const selectAdminLevelThreeUpdatedItem = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.update);

export const selectAdminLevelThreeReadItem = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.read);

export const selectAdminLevelThreeDeletedItem = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.delete);

export const selectAdminLevelThreeSearchedItems = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.search);

export const selectAdminLevelThreeItemsCount = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.count);

export const selectAdminLevelThreeItemsFilter = createSelector([selectAdminLevelThree], (AdminLevelThree) => AdminLevelThree.filter);